import { combineReducers } from '@ngrx/store';
import { AuthStateInterface } from './auth.state';
import { AuthSessionReducer } from './auth-session/auth-session.reducer';

export const reducers = combineReducers<AuthStateInterface>({
  authSession: AuthSessionReducer,
});
